import { useCallback, useEffect, useState } from "react";

// Breathing room left below a table so it does not sit flush against the
// viewport edge. Screens that scroll to the bottom (virtualised lists) pass 0.
const DEFAULT_BOTTOM_GAP = 25;

function useAutoHeightForContent(isLoading, bottomGap = DEFAULT_BOTTOM_GAP) {
	const [tableHeight, setTableHeight] = useState(0);

	const handleTableHeight = useCallback(() => {
		const tableContainer = document.getElementById(
			"table-scroll-wrapper-container"
		);
		if (tableContainer) {
			let tableContainerTop = tableContainer.getBoundingClientRect().top;
			setTableHeight(window.innerHeight - tableContainerTop - bottomGap);
		}
	}, [bottomGap]);

	useEffect(() => {
		// Small delay to ensure DOM positioning is complete
		const timer = setTimeout(handleTableHeight, 100);
		return () => clearTimeout(timer);
	}, [handleTableHeight, isLoading]);

	useEffect(() => {
		document.body.style.overflowY = "hidden";
		window.addEventListener("resize", handleTableHeight);

		return () => {
			window.removeEventListener("resize", handleTableHeight);
			document.body.style.overflowY = "auto";
		};
	}, [handleTableHeight]);

	return { tableHeight };
}

export { DEFAULT_BOTTOM_GAP };
export default useAutoHeightForContent;
